/**
 * Typed accessor for compile-time env vars.
 *
 * Every env var must be declared here. Components/services never read
 * `import.meta.env` directly.
 */
export interface AppEnv {
  apiBaseUrl: string | null;
  appInsightsConnectionString: string | null;
  mode: string;
}

let cached: AppEnv | null = null;

const read = (): AppEnv => ({
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || null,
  appInsightsConnectionString: import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING || null,
  mode: import.meta.env.MODE ?? 'development',
});

export const getEnv = (): AppEnv => {
  if (cached === null) cached = read();
  return cached;
};

/** Internal: only used by tests to reset between cases. */
export const resetEnvForTest = (): void => {
  cached = null;
};
